<template>
  <div>
<!--    <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'日清补录'}]" />-->
    <Breadtabsheader/>
    <div class="h-content">
      <!-- 搜素条件 -->
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <!-- <el-form-item label="创客">
  <el-input v-model="q.userCode" placeholder="请输入创客姓名/工号" :clearable="true"></el-input>
</el-form-item> -->
          <el-form-item  label="拜访日期">
            <el-date-picker type="date" placeholder="选择日期" v-model="q.visitDate"
                            value-format="yyyy-MM-dd" style="width: 100%;">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="拜访客户">
            <el-input v-model="q.customerName" placeholder="请输入拜访客户名称"></el-input>
          </el-form-item>
        </el-form>

        <!-- 展开搜素 -->
        <div class="l-screenBox">
          <!-- <div class="l-screen" @click="collapseChange">
              <img :src="isScreen?closeScreen:drawScreen" alt="">
              <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
          </div> -->
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="selectPageAll">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
<!--            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="create">-->
<!--              新建目标-->
<!--            </el-button>-->
          </div>
        </div>
      </div>
      <!-- 结果展示 -->
      <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
        <!-- @selection-change="handleSelectionChange" -->
        <el-table
            ref="multipleTable"

            :data="tableData"
            :border="true"
            stripe
            max-height="560"
            style="width: 100%" >
          <el-table-column
              label="序号"
              type="index"
              width="50">
          </el-table-column>
          <el-table-column prop="planUserName" label="创客" min-width="12%" ></el-table-column>
          <el-table-column prop="deptName" label="部门" min-width="12%" ></el-table-column>
          <el-table-column prop="quyuName" label="区域" min-width="12%" ></el-table-column>
          <el-table-column prop="projectName" label="项目分类" min-width="15%" ></el-table-column>
          <!--                        <el-table-column prop="chainGroupName" label="抢入链群" width="180" ></el-table-column>-->
          <el-table-column prop="customerName" label="拜访客户" min-width="25%" ></el-table-column>
          <el-table-column prop="visitContent" show-overflow-tooltip="" label="拜访内容" min-width="25%" ></el-table-column>
          <el-table-column prop="visitDate" label="拜访日期" min-width="12%"></el-table-column>
          <el-table-column prop="visitDate" label="拜访日期" min-width="12%">
            <template slot-scope ="scope">
                        <span v-if="scope.row.planId == null ">
                          未补录
                        </span>
                        <span v-if="scope.row.planId != null">
                          已补录
                        </span>
            </template>
          </el-table-column>

          <el-table-column
              label="操作"
              fixed="right"
              width="120px">
            <template slot-scope="scope">
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn"
                  @click="openNissin(scope.row)"
              >补录</el-button>
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn"
                  @click="updateDetail(scope.row)"
              >编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 弹出层 -->
      <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="newDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{titleDig}}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;">
            <el-form :model="add" label-position="right" :inline="true" label-width="80"
                     class="demo-ruleForm h-formbLine h-formbLine1">
              <el-form-item label="年度" class="h-elformWrap-3" prop="username">
                <el-select filterable v-model="add.year"  placeholder="请选择"
                           @change="getWeeksBySelectYear">
                  <el-option
                      v-for="(item) in yearList"
                      :key="item"
                      :label="item"
                      :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="周" class="h-elformWrap-3" prop="week">
                <el-select filterable @change="selectWeek" v-model="add.week"  placeholder="请选择">
                  <el-option
                      v-for="(item) in weekList"
                      :key="item.week"
                      :label="item.weekStr"
                      :value="item.week">
                  </el-option>
                </el-select>
              </el-form-item>
              <div style="width: 96%;margin: 0 auto;padding-bottom: 10px;">
                <!-- <el-checkbox-group  v-model="add.userList" @change="groupChange">
                    <el-checkbox
                        v-for="(item, index) in authTypeList"
                        value="item.id"
                        :key="index"
                        :label="item.id"
                        class="checkbox-div"
                    > {{item.projectName}}-{{item.targetContent}}</el-checkbox>
                </el-checkbox-group> -->

                <el-radio-group  v-model="add.userList" @change="changeHandler">
                  <el-radio class="radio"  v-for="(item, index) in authTypeList" value="item.id"
                            :key="index"
                            :label="item.id"> {{item.projectName}}-{{item.targetContent}}</el-radio>

                </el-radio-group>


              </div>
              <el-form-item label="客户名称" prop="euName" >
                <el-select v-model="add.customerName" remote :disabled="disEdit"
                           filterable :filter-method="showFormList" clearable placeholder="请输入"
                           :remote-method="showFormList" @change="showFormList" >
                  <el-option v-for="(item) in optionList"
                             :key="item.id"
                             :label="item.userName"
                             :value="item.userName">
                  </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="客户名称">
                  <el-autocomplete
                      v-model="add.customerName"
                      size="mini"
                      :fetch-suggestions="querySearchGroup"
                      @select="selectGroup"

                      @input="groupListMe"
                      :disabled="disEdit"
                      clearable
                      placeholder="请输入内容"
                  ></el-autocomplete> -->

              <!-- <el-input v-model="add.customerName" :disabled="disEdit"></el-input> -->
              <!-- </el-form-item> -->
              <el-form-item label="拜访时间">
                <el-date-picker
                    v-model="add.visitDateNew"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="项目分类">
                <el-select v-model="add.projectName" :disabled="disEdit">
                  <el-option v-for="(item) in projectList"
                             :key="item.id"
                             :label="item.projectName"
                             :value="item.projectName">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="拜访内容" class="h-elformWrap-1">
                <el-input type="textarea"  v-model="add.targetContent" :disabled="disEdit"></el-input>
              </el-form-item>
              <el-form-item style="display:none">
                <el-input v-model="add.clearType"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 日清 -->
      <el-dialog :close-on-click-modal="false" :visible.sync="writeNissin" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{titleDig}}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;">
            <el-form :model="add" label-position="right" :inline="true" label-width="80"
                     class="demo-ruleForm h-formbLine h-formbLine1">
              <div style="width: 96%;margin: 0 auto;padding-bottom: 10px;">
                <el-checkbox-group v-if="edit.clearType == 1"  v-model="edit.userList" @change="groupChangeEdit">
                  <el-checkbox
                      v-for="(item) in authTypeListEdit"
                      :key="item.id"
                      :label="item.id"
                      :value= "item.id"
                      class="checkbox-div"
                  > {{item.projectName}}-{{item.targetContent}}</el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="h-formLine">
                <el-form-item  label="客户名称" prop="department" >
                  <el-input v-model="nissin.customerName" disabled>
                  </el-input>
                </el-form-item>
                <el-form-item  label="项目分类" prop="department" >
                  <el-input v-model="nissin.projectName" disabled>
                  </el-input>
                </el-form-item>h
                <el-form-item  label="计划内容" prop="department"  class="h-elformWrap-1">
                    <textarea v-model="nissin.visitContent" disabled style="width:100%; height: 70px" >
                    </textarea>
                </el-form-item>
              </div>

              <div class="h-formLine projectCon"><p><i>日清提报</i></p>
                <el-form-item  label="部门科室" prop="department" >
                  <el-input v-model="nissin.department" placeholder="请输入部门/科室/岗位">
                  </el-input>
                </el-form-item>

                <el-form-item  label="联系人" prop="contactUserName" >
                  <el-input v-model="nissin.contactUserName" placeholder="请输入">
                  </el-input>
                </el-form-item>

                <el-form-item  label="联系电话" prop="telephone" >
                  <el-input v-model="nissin.telephone" onkeyup="value=value.replace(/[^\d]/g,'')"  placeholder="请输入">
                  </el-input>
                </el-form-item>

                <el-form-item label="抢入链群" prop="lianqun">
                  <brselect category="crm_lianqun" :v="nissin.lianqunCode" :showcode="true"
                            v-model="nissin.lianqunCode" clearable></brselect>
                </el-form-item>

                <el-form-item label="日清内容" class="h-elformWrap-1">
                    <textarea v-model="nissin.dailyContent" placeholder="请输入" style="width:100%; height: 70px">
                    </textarea>
                </el-form-item>
                <el-form-item style="display:none">
                  <el-input v-model="nissin.dailyContent"></el-input>
                </el-form-item>
              </div>
            </el-form>
          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
            <!--                    <el-button class="h-btn h-bBtn h-bggreen" @click="saveCreate" v-show="isShowSaveCredit">暂存-->
            <!--                    </el-button>-->
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveNissin()">保存</el-button>
          </div>
        </div>
      </el-dialog>
      <!-- 编辑 -->
      <el-dialog :close-on-click-modal="false" :visible.sync="editDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{titleDig}}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;">
            <el-form :model="add" label-position="right" :inline="true" label-width="80"
                     class="demo-ruleForm h-formbLine h-formbLine1">
              <div style="width: 96%;margin: 0 auto;padding-bottom: 10px;">
                <el-checkbox-group v-if="edit.clearType == 1"  v-model="edit.userList" @change="groupChangeEdit">
                  <el-checkbox
                      v-for="(item) in authTypeListEdit"
                      :key="item.id"
                      :label="item.id"
                      :value= "item.id"
                      class="checkbox-div"
                  > {{item.projectName}}-{{item.targetContent}}</el-checkbox>
                </el-checkbox-group>
              </div>
              <el-form-item label="客户名称">
                <el-autocomplete
                    v-model="edit.customerName"
                    size="mini"
                    :fetch-suggestions="querySearchGroup1"
                    @select="selectGroup1"
                    @input="groupListMe1"
                    :disabled="disEdit"
                    clearable
                    placeholder="请输入内容"
                ></el-autocomplete>
                <!-- <el-input v-model="add.customerName" :disabled="disEdit"></el-input> -->
              </el-form-item>
              <el-form-item label="拜访时间">
                <el-date-picker
                    v-model="edit.visitDateNew"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="项目分类">
                <el-select v-model="edit.projectName" :disabled="disEdit">
                  <el-option v-for="(item) in projectList"
                             :key="item.id"
                             :label="item.projectName"
                             :value="item.projectName">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="拜访内容" class="h-elformWrap-1">
                <el-input type="textarea"  v-model="edit.targetContent"  :disabled="disEdit"></el-input>
              </el-form-item>
              <el-form-item style="display:none">
                <el-input v-model="edit.clearType"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
            <!--                    <el-button class="h-btn h-bBtn h-bggreen" @click="saveCreate" v-show="isShowSaveCredit">暂存-->
            <!--                    </el-button>-->
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitUpdate()">保存</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="h-tableB h-mrt30">
      <div class="h-tableBL" style="margin-left: 23px">
<!--        <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"-->
<!--                   @click="exportExcel">批量导出-->
<!--        </el-button>-->
      </div>
      <div class="h-pagination2">
        <pagination :page="q" @query="selectPageAll" />
      </div>
    </div>
  </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import cost from '../../../routes/cost';
export default {
  data() {
    return {
      q:{
        visitDate:'',
        planUserName:'',
        customerName:'',
        quyuCode:'',
        pageNo:1,
        pageSize:10,
        total:0,
      },
      size:'',
      tableData: [],
      newDialog:false,
      writeNissin:false,
      editDialog:false,
      // 展开折叠筛选
      isScreen:false,
      yearList:[new Date().getFullYear(),new Date() .getFullYear()+1],
      weekList:[],
      add:{
        year:'',
        week:'',
        userList:[0],
        targetContent:'',
        customerName:'',
        customerCode:'11',
        visitDateNew:'',
        clearType:'2',
        projectName:''
      },
      edit:{
        id:'',
        deId:'',
        userList:[0],
        targetContent:'',
        customerName:'',
        visitDateNew:'',
        clearType:'',
        projectName:''
      },
      nissin:{
        bid:'',
        userCode:'',
        userName:'',
        answerTime:'',
        defultFlag:'',
        dailyQuestion:'',
        customerName:'',
        visitDate:'',
        endDate:'',
        visitContent:"",
        dailyContent:'',
        isProject: 0,
        id:'',
        isConShow:false,
        isProjectBtn:false,
        chainGroupName:'',
        chainGroupCode:'',
        visitEffect:'',
        title:'',
        statusR:'',
        selectVisitEffect:['a','b'],
        gameTitles: [],
        subJieProgess: [], // 需求子节点数据
        childMsgId: '',
        //yucePrice: '', // 月预算在下单
        expConvDate: '',
        department:'',
        telephone:'',
        contactUserName:"",
        lianqunCode:'',
      },

      authTypeListEdit:[],
      wirteNissinList:[],
      disEdit:false,
      workList:[],
      AuthoCheck: '',
      authTypeList: [],
      userList: [0],
      weekPlanList:[],
      groupList: [],
      groupArr:[],
      deptList: [],
      titleDig:"",
      optionList:[],
      projectList:[],
    }
  },
  methods: {
    //明细导出
    exportExcel() {
      updownfile.down("/api/swyl/v1/dailyClear/userDailyClear/newDownloadExcel",this.q,"post",'data');
    },
    getOption(){
      this.optionList=[]
      var data  = ''
      ss.MuBiao.getUser(data).then(res => {
        console.log(res)
        this.optionList = res.msg
      })
    },
    showFormList(value) {
      ss.MuBiao.getUser(value).then(res => {
        console.log(res)
        this.optionList = res.msg
      })
    },
    //项目类型
    getProject(){
      ss.MuBiao.getProject().then(res => {
        console.log(res)
        this.projectList = res.msg
      })
    },
    getDept(q){
      ss.MuBiao.getDeptList(q).then(rd => {
        this.deptList = rd;
      })
    },
    groupChangeEdit() {
      if (this.edit.userList.length > 1) {
        this.edit.userList.shift();
      }
      console.log(this.edit.userList)
      var arr3 =[]
      this.edit.userList.forEach((item) => {
        this.authTypeListEdit.forEach((element) => {
          if (item == element.id) {
            arr3.push(element)
          }
        })
      })
      console.log(arr3)
      if(arr3.length == 0){
        this.edit.targetContent = '',
            this.edit.customerName= ''
        //this.add.visitDateNew= ''
        this.edit.clearType = 2
        this.disEdit = false
      }else{
        this.edit.targetContent = arr3[0].targetContent,
            this.edit.customerName= arr3[0].customerName
        this.edit.clearType = 1
        this.disEdit = true
        this.edit.deId = this.edit.userList[0]
      }
    },
    commitUpdate(){
      var data ={
        id:this.edit.id,
        deId:this.edit.deId,
        targetContent:this.edit.targetContent,
        customerName:this.edit.customerName,
        visitDate:this.edit.visitDateNew,
        clearType:this.edit.clearType,
        visitContent:this.edit.targetContent,
        projectName:this.edit.projectName
      }
      console.log("data",data)
      ss.MuBiao.updateById(data).then(res =>{
        console.log(res)
        if(res.f == true ){
          this.editDialog= false
          console.log(res)
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.selectPageAll()
          this.newDialog = false
        }else{
          this.$message.error(res.msg);
        }
      })
    },

    openNissin(row){
      var data1 ={
        visitDate:row.visitDate,
      }
          console.log("data1",data1)
          // console.log(res)
          this.writeNissin = true,
          this.wirteNissinList = [];
          this.titleDig="日清补录";
          this.nissin = row;
          this.nissin.isProject = 0;
          var data = this.nissin
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.selectPageAll()
          this.newDialog = false
    },
    saveNissin(){
      this.nissin.chainGroupCode = this.nissin.lianqunCode
      var data = this.nissin
      var list = [];
      this.chainGroupCode = data.lianqunCode;
      list.push(data);
      ss.MuBiao.updatePlanAdd(list).then(res =>{
        console.log(res)
        if(res.f == true ){
          this.writeNissin= false
          console.log(res)
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.selectPageAll()
          this.newDialog = false
        }else{
          this.$message.error(res.msg);
        }
      })

    },



    updateDetail(row){
      //
      this.authTypeListEdit=[]
      this.titleDig="编辑内容"
      var data = row.id
      ss.MuBiao.getDailyPlanSingle(data).then(res =>{
        console.log(res.msg)
        this.authTypeListEdit = res.msg.detailList1
        if(res.msg.clearType == 1){
          var obj=res.msg.detailList1.find(function (obj) {
            return obj.status ==1//取出this.studentL里的id为1的那条数据所有的信息
          })
          this.disEdit = true
          this.edit.deId = obj.id
        }else{
          this.disEdit = false
          this.edit.deId = res.msg.detailList1[0].id
        }
        //res.msg.id
        this.edit.userList.push("202108077fbF2uAn")
        this.edit.id = res.msg.id
        this.edit.customerName = row.customerName
        this.edit.projectName = row.projectName
        this.edit.visitDateNew = row.visitDate
        this.edit.targetContent = row.visitContent
        this.edit.clearType = res.msg.clearType
      })
      console.log(row)
      this.editDialog = true
    },
    groupListMe() {
      var data  = this.add.customerName
      ss.MuBiao.getUser(data).then(res => {
        console.log(res)
        this.groupList = []
        this.groupArr = []
        this.groupList = res.msg
        for(let item of this.groupList) {
          this.groupArr.push({
            value:item.userName,
            id:item.userCode
          })
        }
      })
    },
    querySearchGroup(queryString, cb) {
      var groupArr = this.groupArr;
      cb(groupArr);
    },
    selectGroup(val) {
      console.log(val)
      this.add.customerName= val.value
    },
    groupListMe1() {
      var data  = this.edit.customerName
      ss.MuBiao.getUser(data).then(res => {
        console.log(res)
        this.groupList = []
        this.groupArr = []
        this.groupList = res.msg
        for(let item of this.groupList) {
          this.groupArr.push({
            value:item.userName,
            id:item.userCode
          })
        }
      })
    },
    querySearchGroup1(queryString, cb) {
      var groupArr = this.groupArr;
      cb(groupArr);
    },
    selectGroup1(val) {
      console.log(val)
      this.edit.customerName= val.value
    },
    commitCreate() {
      console.log(this.add)
      var data =[{
        year:this.add.year,
        week:this.add.week,
        targetContent:this.add.targetContent,
        customerName:this.add.customerName,
        visitDate:this.add.visitDateNew,
        clearType:this.add.clearType,
        customerCode:this.add.customerCode,
        id:this.add.id,
        projectName:this.add.projectName
      }]
      console.log(data)
      ss.MuBiao.insertAll(data).then(res => {
        console.log(res)
        if(res.f == true ){
          console.log(res)
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.selectPageAll()
          //this.newDialog = false
          this.closeDialog()
        }else{
          this.$message.error(res.msg);
        }
      })
    },
    changeHandler(value) {
      //console.log('改变之后的值是:' + value)
      let data =  this.authTypeList
      let item = this.add.userList
      // 使用find方法根据id查询对应对象
      let a =  data.find((ele)=>{
        return ele.id == item
      });
      console.log(a) //1
      var arr3 =a
      if(!arr3.id){
        this.add.targetContent = '',
            this.add.customerName= ''
        this.add.clearType = 2
        this.disEdit = true
      }else{
        this.add.targetContent = arr3.targetContent,
            this.add.customerName= arr3.customerName
        this.add.clearType = 1
        this.add.projectName = arr3.projectName
        this.disEdit = false
        this.add.id = this.add.userList
      }
    },
    groupChange() {
      console.log("变化", this.add.userList);
      if (this.add.userList.length > 1) {
        this.add.userList.shift();
      }
      console.log(this.add.userList)
      var arr3 =[]
      this.add.userList.forEach((item) => {
        this.authTypeList.forEach((element) => {
          if (item == element.id) {
            arr3.push(element)
          }
        })
      })
      console.log(arr3)
      if(arr3.length == 0){
        this.add.targetContent = '',
            this.add.customerName= ''
        //
        //this.add.visitDateNew= ''
        this.add.clearType = 2
        this.disEdit = false
      }else{
        this.add.targetContent = arr3[0].targetContent,
            this.add.customerName= arr3[0].customerName
        this.add.clearType = 1
        this.add.projectName = arr3[0].projectName
        this.disEdit = true
        this.add.id = this.add.userList[0]
      }
    },

    //获得周计划列表
    getWeekPlan(year,week){
      var year = this.add.year
      var week = parseInt(this.add.week)
      var data = {
        year:year,
        week:week
      }
      console.log(data)
      ss.MuBiao.getListPlan(data).then(res => {
        console.log(res)
        if(res.f == true ){
          console.log(res)
          this.authTypeList = res.msg
        }else{
          this.$message.error(res.msg);
        }
      })
    },

    deleteSingle(id){
      //
      var data = id
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ss.MuBiao.delById(data).then(res => {
          console.log(res)
          if(res.f == true ){
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.selectPageAll()
          }else{
            this.$message.error(res.msg);
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    selectPageAll(){
      ss.MuBiao.clearPlanAddPage(this.q).then(res => {
        console.log(res.msg)
        this.tableData = res.records
        this.q.total = res.total
      })
    },
    getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
      this.$set(this.add, "visitDateNew", defaultDate);
    },

    //新增日清
    create(){
      this.newDialog = true;
      this.titleDig="新建日计划"
      this.add.week = this.weekList[0].week
      this.getWeekPlan()

    },
    getWeeks(y){
      ss.MuBiao.getWeekList({year:y}).then(rd => {
        this.weekList = rd;
      })
    },
    getWeeksBySelectYear(){
      this.getWeeks(this.add.year);
      ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
        this.addlianqunList = rd;
      })
    },
    selectWeek(){
      console.log(this.add.week)
      this.getWeekPlan()
    },
    getqWeeksBySelectYear(){
      this.getqWeeks(this.q.year,1);
    },
    // 展开折叠
    collapseChange(){
      this.isScreen = !this.isScreen;
    },
    rest(){
      var pageSize=this.q.pageSize;
      var pageNo=this.q.pageNo;
      var total=this.q.total;
      this.q= {
        pageSize: pageSize,
        pageNo: pageNo,
        total:total,
        visitDate:''
      }
    },
    exit(){
      this.closeDialog()
    },
    closeDialog(){
      this.newDialog = false
      this.editDialog = false
      this.writeNissin = false
      this.xxx = '';//清空数据

      this.add.targetContent='',
          this.add.customerName='',
          this.add.visitDateNew='',
          this.add.clearType='2',
          this.add.projectName=''

      this.edit.targetContent='',
          this.edit.customerName='',
          this.edit.visitDateNew='',
          this.edit.projectName=''

    },
  },
  watch:{
    'add.customerName': {
      deep: true,
      handler: function (newVal,oldVal){
        this.groupArr = [];//这是定义好的用于存放下拉提醒框中数据的数组
        var len = this.groupList.length;//groupList
        var arr = [];
        for (var i = 0; i < len; i++) {//根据输入框中的值进行模糊匹配
          if (this.groupList[i].name.indexOf(this.add.customerName) >= 0) {
            arr.push({
              value:this.groupList[i].name,
              id:this.groupList[i].id
            })
          }
        }
        this.groupArr = arr
      }
    },
  },
  created(){
    this.getNowTime()
    this.selectPageAll()
    this.add.year =  this.yearList[0]
    this.getWeeks(new Date().getFullYear());
    // this.add.week = this.workList[0].week
    this.getOption()
    this.getProject()
    this.getDept();
  }
}
</script>
<style scoped>
/deep/ .h-formbLine .el-form-item__label{
  width:80px;
}
/deep/  .h-formbLine .el-form-item__content{
  width:150px;
}
/deep/ .h-elformWrap-1 .el-form-item__content{
  width: 78%;
}

.projectCon p{
  justify-content: space-between;
  align-items:center;
  font-size: 14px;
  border-bottom:#1b78e6 1px dashed;
  padding: 5px 0;
  margin: 0 auto 10px auto;
  color: #1b78e6;
}
</style>
